import "react-select/dist/react-select.css";
import "react-virtualized-select/styles.css";
import React, { Component } from 'react';
import Select from "react-virtualized-select";
import {data} from "./data/data";
import {population} from "./data/population";

class App extends Component {
    constructor(props) {
        super(props);

        console.log({data});

        this.state = {
            result: null,
            streets: [],
            selectedPopulation: null,
            selectedStreet: null,
        };
    }

    calculateResult = (selectedPopulation, selectedStreet) => {
        let result = 0;
        const ratings = data[selectedPopulation.label][selectedStreet.label];
        if (Array.isArray(ratings) && ratings.length > 0) {
            result = Math.min(...ratings);
        }

        this.setState({result: result})
    }

    handlePopulationChange = selectedPopulation => {
        this.setState({ selectedPopulation });
        let result = [];
        Object.keys(data[selectedPopulation.label]).forEach((streetName) => {
            result.push({value: streetName, label: streetName});
        })
        this.setState({streets: result})
    };

    handleStreetChange = selectedStreet => {
        this.setState({ selectedStreet });
    };

    render() {
        const { selectedPopulation, selectedStreet, result } = this.state;

        return (
            <div>
                <div className="calculate-fields">
                    <div>
                        <p>יישוב</p>
                        <Select
                            value={selectedPopulation}
                            onChange={this.handlePopulationChange}
                            options={population}
                            placeholder=""
                        />
                    </div>

                    <div>
                        <p>רחוב</p>
                        <Select
                            value={selectedStreet}
                            onChange={this.handleStreetChange}
                            options={this.state.streets}
                            placeholder=""
                        />
                    </div>

                    <button onClick={() => this.calculateResult(selectedPopulation, selectedStreet)}>לחישוב</button>
                </div>

                <p className="calculate-result">
                    <strong>תוצאה: </strong>
                    {' '}
                    אזור סטטיסטי מינימלי
                    {' '}
                    {result}
                </p>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx